export default {
  'creditTicket.creditpayment': 'Your credit payment in the amount',
  'creditTicket.creditsuccesspayment': 'The payment was made successfully',
  'creditTicket.flightrezerv':
    'Your temporary flight reservation is being processed',
  'creditTicket.reservtime': 'Pay attention to',
  'creditTicket.reservcarefulcredit': 'the validity date',
  'creditTicket.reservtimecareful': '  of the reservation',
  'creditTicket.beforesalecareful': 'Issue before the date',
  'creditTicket.successreserve':
    'Your reservation has been successfully completed',
  'creditTicket.followupnumber': 'follow up number',
  'creditTicket.reservationdeadline': 'Reservation deadline',
  'creditTicket.equipmentname': 'Equipment name',
  'creditTicket.Cabinname': 'Cabin name',
  'creditTicket.flightnumber': 'Flight number ',
  'creditTicket.cancellationofreservation': 'Cance reservation',
  'creditTicket.iwillpaylater': 'paylater',
  'creditTicket.paymentandissue': 'payment and issue',
  'creditTicket.allowableload': 'Allowable load',
};
